import { getOrderlineDetails } from '@backmarket/http-api/src/api-specs-my-orders-api/endpoints'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'

export function useOrderlineDetails({ orderlineId }: { orderlineId: number }) {
  return useHttpFetch(getOrderlineDetails, {
    pathParams: {
      orderlineId,
    },
    immediate: false,
  })
}
